import styled from "styled-components";

export type TTrophyBadgeSize = "xs" | "sm" | "md" | "lg" | "xl";

export const BADGE_DIMENSIONS: Record<TTrophyBadgeSize, number> = {
  xs: 32,
  sm: 40,
  md: 56,
  lg: 72,
  xl: 96,
};

// All in the fixed 0-0 100x100 viewBox — constant regardless of rendered
// pixel size, matching the source design (Assets/Trophies).
export const RING_WIDTH = 5;
export const RING_RADIUS = 44;
export const DISK_RADIUS = 36;
export const CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

export const BadgeWrapper = styled.div<{
  $interactive: boolean;
  $opacity: number;
}>`
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  opacity: ${({ $opacity }) => $opacity};
  transition:
    opacity 0.15s ease,
    transform 0.15s ease;

  ${({ $interactive }) =>
    $interactive &&
    `
      &:hover {
        opacity: 0.85;
        transform: translateY(-2px);
      }
    `}
`;

// Unfilled featured slot. Dashed + a "+" glyph reads as "add one here"
// rather than the flat black circle this used to be, which felt like a
// missing/broken state rather than an invitation.
export const EmptyCircle = styled.div<{
  $size: TTrophyBadgeSize;
  $interactive: boolean;
}>`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy300};
  border: 1.5px dashed ${({ theme }) => theme.colors.navy50};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.shade300};
  cursor: ${({ $interactive }) => ($interactive ? "pointer" : "default")};
  display: flex;
  flex-shrink: 0;
  height: ${({ $size }) => BADGE_DIMENSIONS[$size]}px;
  justify-content: center;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
  width: ${({ $size }) => BADGE_DIMENSIONS[$size]}px;

  ${({ $interactive, theme }) =>
    $interactive &&
    `
      &:hover {
        background: ${theme.colors.navy400};
        border-color: ${theme.colors.goldStar};
        color: ${theme.colors.goldStar};
      }
    `}
`;
